export default __webpack_public_path__ + "static/zimbabwe-6d4653a643d5c07eba2e3739484f2117.jpeg";